import React, { forwardRef } from 'react'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
import styled from 'styled-components'
import LineArrow from '../../../assets/icons/JSX/LineArrow'

interface NavigationButtonProps {
  text?: string
  onClick?: () => void
  disabled?: boolean
  type?: 'submit' | 'button' | 'reset'
  buttonType?: 'next' | 'prev'
  fullWidth?: boolean
  style?: React.CSSProperties
}

const NavigationButton = forwardRef<HTMLButtonElement, NavigationButtonProps>(
  ({ text, onClick, disabled, type, buttonType = 'next', fullWidth = false, style }, ref) => {
    return (
      <Button
        ref={ref}
        style={style}
        $buttonType={buttonType}
        $fullWidth={fullWidth}
        onClick={onClick}
        disabled={disabled}
        type={type ?? 'button'}
      >
        {buttonType === 'next' && (
          <>
            <span>{text}</span>
            <div>
              <LineArrow />
            </div>
          </>
        )}

        {buttonType === 'prev' && (
          <>
            <div>
              <LineArrow />
            </div>
            <span>{text}</span>
          </>
        )}
      </Button>
    )
  },
)

export default NavigationButton

const Button = styled.button<{ $buttonType: 'next' | 'prev'; $fullWidth: boolean }>`
  border: ${({ $buttonType }) =>
    $buttonType === 'next' ? '1px solid transparent' : `1px solid ${Colors.primaryBlack}`};
  outline: none;
  user-select: none;
  margin: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 11px 60px;
  border-radius: 4px;
  width: ${({ $fullWidth }) => ($fullWidth === true ? '100%' : 'fit-content')};
  background-color: ${({ $buttonType }) => ($buttonType === 'next' ? Colors.primaryRed : 'transparent')};

  &:disabled {
    background-color: ${Colors.secondaryGrey};
    color: ${Colors.white};
    &:hover {
      background-color: ${Colors.secondaryGrey};
      color: ${Colors.white};
    }
  }

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    color: ${({ $buttonType }) => ($buttonType === 'next' ? Colors.white : Colors.primaryBlack)};
    margin-right: ${({ $buttonType }) => ($buttonType === 'next' ? '6px' : '0px')};
    margin-left: ${({ $buttonType }) => ($buttonType === 'prev' ? '6px' : '0px')};
  }

  div {
    svg {
      width: 18px;
      height: 10px;
      margin-top: ${({ $buttonType }) => ($buttonType === 'next' ? '-4.5px' : '-5px')};
      fill: ${({ $buttonType }) => ($buttonType === 'next' ? Colors.white : Colors.primaryBlack)};
      transform: ${({ $buttonType }) => ($buttonType === 'next' ? 'rotate(0deg)' : 'rotate(180deg)')};
    }
  }

  &:hover {
    background-color: ${({ $buttonType }) => ($buttonType === 'next' ? Colors.hoverRed : Colors.primaryBlack)};
    border-color: ${({ $buttonType }) => ($buttonType === 'next' ? 'transparent' : Colors.primaryBlack)};
    span {
      color: ${Colors.white};
    }
    svg {
      fill: ${Colors.white};
    }
  }

  &:active {
    opacity: 0.8;
  }

  ${Responsive.mobile} {
    padding: 11px 20px;
    width: 100%;
  }
`
